export const cateringMenu = {
  coldCabinet: {
    filledCroissants: [
      { name: "Ham, Cheese, Tomato", price: 6 },
      { name: "Cheese & Tomato", price: 6 },
      { name: "Chicken, Cranberry, Brie", price: 6 }
    ],
    clubSandwiches: [
      { name: "Chicken", price: 4 },
      { name: "Ham", price: 4 },
      { name: "Avocado", price: 4 }
    ],
    wraps: [
      { name: "Chicken Satay", price: 4 },
      { name: "Vegetarian", price: 4 }
    ],
    sliders: [
      { name: "Pulled Pork", price: 6.5 },
      { name: "Battered Fish", price: 6.5 }
    ],
    miniBurger: [
      { name: "Beef", price: 6.5 },
      { name: "Crispy Chicken", price: 6.5 }
    ],
    baoBuns: [
      { name: "Crispy Chicken", price: 6.5 }
    ],
    sushi: [
      { name: "Salmon", price: 1.8, min: 9 },
      { name: "Chicken", price: 1.8, min: 9 },
      { name: "Tuna", price: 1.8, min: 9 },
      { name: "Avocado", price: 1.8, min: 9 }
    ]
  },
  sweets: {
    fruitSkewers: 4,
    miniScones: [
      { name: "Cheese", price: 3.5 },
      { name: "Dates", price: 3.5 }
    ],
    miniMuffins: [
      { name: "Mixed Berry", price: 4 },
      { name: "Banana White Chocolate Chip", price: 4 }
    ],
    miniSlices: [
      { name: "Chocolate Caramel Slice", price: 3.5 },
      { name: "Walnut Caramel Slice", price: 3.5 },
      { name: "White Chocolate Macadamia", price: 3.5 },
      { name: "Ginger Crunch", price: 3.5 },
      { name: "Triple Chocolate Brownie", price: 3.5 }
    ],
    miniCream: [
      { name: "Mini Donut", price: 4.5 },
      { name: "Mini Lamington", price: 4.5, flavors: ["Chocolate", "Raspberry"] }
    ],
    miniCakes: [
      { name: "Mud Cake", price: 4.5 },
      { name: "Carrot Cake", price: 4.5 },
      { name: "New York Cheese Cake", price: 4.5 }
    ]
  },
  hotSavoury: {
    miniPies: [
      { name: "Mince", price: 3.5 },
      { name: "Creamy Chicken", price: 3.5 },
      { name: "Mince Potato", price: 4 }
    ],
    miniQuiches: [
      { name: "Bacon & Egg", price: 4 },
      { name: "Spinach & Feta", price: 4 },
      { name: "Chicken & Mushroom", price: 4 }
    ],
    rollsAndSkewers: [
      { name: "Sausage Roll", price: 3.5 },
      { name: "Vegetarian Mexican Roll", price: 4 },
      { name: "Chicken Skewer", price: 4.5 }
    ]
  },
  extras: {
    woodenCutlery: 0.5,
    brownNapkin: 0.2,
    plates: 0.5,
    miniButter: 0.5
  },
  platters: {
    clubSandwich: { small: 42, medium: 84, large: 126 },
    sushi: { small: 25, medium: 49, large: 80 },
    cheesePlatter: { small: 95, large: 150 },
    fruitPlatter: { small: 28, medium: 55, large: 85 },
    miniSlices: { small: 38, medium: 75, large: 110 },
    miniMuffinScones: { small: 38, medium: 75, large: 110 },
    miniBurger: { small: 75, medium: 145, large: 215 },
    baoBun: { small: 75, medium: 145, large: 215 },
    sliders: { small: 75, medium: 145, large: 215 },
    hotSavoury: { small: 65, large: 125 }
  },
  lunchBoxes: {
    minOrder: 6,
    options: [
      { name: "Pie + Fruit Pot", price: 13 },
      { name: "Beef Lasagne/Chicken Mushroom Filo/Vegetarian Roll + Salad + Sweet", price: 18 },
      { name: "Wrap + Fruit Pot + Sweet", price: 21 },
      { name: "Panini + Fruit Pot", price: 16.5 },
      { name: "Beef Salad + Sweet", price: 18 },
      { name: "Beef Lemon Grass on Rice + Sweet", price: 23 },
      { name: "Sweet Chilli Chicken on Rice + Fruit Pot", price: 23 },
      { name: "Stir Fried Beef with Black Pepper on Rice + Sweet", price: 23 },
      { name: "Spring Roll Noodle Salad + Sweet", price: 19 },
      { name: "Vegetarian Fried Noodle + Sweet", price: 22 }
    ]
  },
  breakfastBoxes: {
    minOrder: 6,
    options: [
      { name: "Scone/Muffin + Large Coffee", price: 11.5 },
      { name: "Scone/Muffin + Sausage Roll + Large Coffee", price: 17 },
      { name: "Bacon & Egg / Egg & Hash Muffin + Large Coffee", price: 14 },
      { name: "Breakfast Wrap + Large Coffee", price: 15.5 }
    ]
  },
  contact: {
    name: "Forage Hill Cafe",
    address: "87a Mclaughlins Road, Wiri, 2104",
    phone: "09 217 2768",
    email: "foragehill@gmail.com"
  },
  cateringInfo: {
    notice: "24 hour notice and cancellation required",
    minOrder: 6
  }
};
